import { NgModule } from '@angular/core';
import { HomePageComponent } from './home-page.component';
import { HomePageRoutingModule } from './home-page-routing.module';
import { HighlightedProductsSectionComponent } from './sections/highlighted-products-section/highlighted-products-section.component';
import { MainBannerSectionComponent } from './sections/main-banner-section/main-banner-section.component';
import { AtpBannerSectionComponent } from './sections/atp-banner-section/atp-banner-section.component';
import { CategoriesSectionComponent } from './sections/categories-section/categories-section.component';
import { OffersSectionComponent } from './sections/offers-section/offers-section.component';
import { AdditionalSectionComponent } from './sections/additional-section/additional-section.component';
import { HeaderComponent } from '@core/components/header/header.component';
import { FooterComponent } from '@core/components/footer/footer.component';
import { NavbarComponent } from '@core/components/navbar/navbar.component';
import { PrimaryBannerSectionComponent } from './sections/primary-banner-section/primary-banner-section.component';
import { SecondaryBannerSectionComponent } from './sections/secondary-banner-section/secondary-banner-section.component';
import { LatestNewsComponentSection } from './sections/latest-news/latest-news-section.component';
import { BrandsSectionComponent } from './sections/brands-section/brands-section.component';
import { FeaturedBrandsService } from './services/featured-brands.service';
import { NvidiaSectionComponent } from './sections/nvidia-section/nvidia-section.component';
import { BombPricesComponent } from './sections/bomb-prices/bomb-prices.component';

@NgModule({
  declarations: [HomePageComponent],
  providers: [FeaturedBrandsService],
  imports: [
    HomePageRoutingModule,
    HighlightedProductsSectionComponent,
    MainBannerSectionComponent,
    AtpBannerSectionComponent,
    CategoriesSectionComponent,
    OffersSectionComponent,
    AdditionalSectionComponent,
    HeaderComponent,
    FooterComponent,
    NavbarComponent,
    PrimaryBannerSectionComponent,
    SecondaryBannerSectionComponent,
    LatestNewsComponentSection,
    BrandsSectionComponent,
    NvidiaSectionComponent,
    BombPricesComponent,
  ],
  exports: [HomePageComponent],
})
export class HomePageModule {}
